import { LOCAL_LNG } from '@flowus/common/const';
import { appI18n } from '@flowus/common/i18n';
import { CreatePageWidthMode } from 'src/hooks/public/get-page-width-fixed';
import { SettingThemeMode } from 'src/services/app/type';

export const themeList = [
  {
    title: appI18n.t('views.settings.general.follow_system'),
    value: SettingThemeMode.system,
  },
  {
    title: appI18n.t('views.settings.general.light_mode'),
    value: SettingThemeMode.light,
  },
  {
    title: appI18n.t('views.settings.general.dark_mode'),
    value: SettingThemeMode.dark,
  },
];

export enum OpenPageMode {
  JUMP = 'jump',
  RIGHT_PAGE = 'rightPage',
}

export const openPageModeList = [
  {
    title: appI18n.t('views.settings.general.jump_to_page'),
    value: OpenPageMode.JUMP,
  },
  {
    title: appI18n.t('views.settings.general.open_right_side'),
    value: OpenPageMode.RIGHT_PAGE,
  },
];

export const createPageWidthList = [
  {
    title: LOCAL_LNG.fixed,
    value: CreatePageWidthMode.FIXED,
  },
  {
    title: appI18n.t('common.adaptive_width'),
    value: CreatePageWidthMode.AUTO,
  },
];
export const createPageWidthFont = [
  {
    title: appI18n.t('views.settings.general.default_font'),
    value: 'default',
  },
];
if (__BUILD_IN__) {
  createPageWidthFont.push(
    ...[
      {
        title: 'Lora',
        value: 'loraVariable',
      },
      {
        title: 'DM Mono',
        value: 'dmMono',
      },
    ]
  );
} else {
  createPageWidthFont.push(
    ...[
      {
        title: appI18n.t('common.font_lxgw'),
        value: 'lxgwWenKai',
      },
      {
        title: appI18n.t('common.font_source_han'),
        value: 'sourceHanSerif',
      },
    ]
  );
}

export const createPageWidthLayout = [
  {
    title: appI18n.t('views.settings.general.compact_layout'),
    value: 'compact',
  },
  {
    title: appI18n.t('views.settings.general.default_layout'),
    value: 'default',
  },
  {
    title: appI18n.t('views.settings.general.loose_layout'),
    value: 'loose',
  },
];
